import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import {sections} from '../../../utils/variables'
import './menu.css'

class Menu extends Component {

    constructor(props){
	super(props)
	this.state = {
	    menuVisible: false
	}
    }
    
    componentDidMount(){
	this.props.loadPages();
    }

    
    render() {

	let {menuVisible} = this.state
	const menuSections = () => {
	    return sections.map((sektion, index) =>		
		<li key={index}><div>{sektion}</div> {menuPages(sektion)}</li>		
	    )
	}

	const menuPages = (section) => {
	    const {pages} = this.props
	    if(pages){
		
		return (<ul>{pages.filter((page) => page.section === section).map((page, index) =>
		    <Link to={'/pages/'+page.title}  key={index}><li to={'/pages/'+page.title}><div>{page.title}</div></li></Link>
		)}{section=='PRODUKCIJE' ? <Link to={'/podcasts'}><li to={'/podcasts'}><div>Prisluhni nam</div></li></Link> : ""}</ul>
		)
		
		
	    }
	}

	const toggleMenu = (menuState) => {
	    
	    if(menuState)
	    	menuVisible = menuState
	    else
		menuVisible = !menuVisible
	    this.setState({menuVisible})
	}
	
	return (

	    <header>
		<div className="logo">
		    <Link to="/">
			<img src="/logo-c.png" alt="logo" />
		    </Link>
		</div>
		<div className={['menu_cont', (menuVisible ? 'menuVisible' : 'menuHidden')].join(' ')}>
		    <button className="manuReducedActions openAction" onClick={() => toggleMenu()}>
			<i className="fa fa-bars"></i>
		    </button>
		    
		    <div className="menu">
			<button className="manuReducedActions closeAction" onClick={() => toggleMenu()}><i className="fa fa-close"></i></button>
			<ul onClick={() => toggleMenu(false)}>
			    {menuSections()}
			    <Link to="/events"><li><div>NOVICE</div></li></Link>
			    <Link to="/contact"><li><div>KONTAKTI</div></li></Link>
			    
			</ul>
		    </div>
		</div>
		
		
		<div className="social_buttons">
		    <a href="https://www.facebook.com/Radijski-oder-2017423601908595/" target="_new"><img src="/slocial_buttons/social_facebook_square.jpg" alt="fb" /></a>
		    <a href="https://www.instagram.com/radijski_oder/" target="_new"><img src="/slocial_buttons/social_instagram_square.jpg" alt="instagram" /></a>

		    
		    {false && <a><img src="/slocial_buttons/social_youtube_square.jpg" alt="youtube" /></a>}
		</div>
	    </header>
	);
    }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Layout/Menu/index.jsx